<ui-dialog
    *ngIf="formGroup"
    #assignInterview
    size="small"
    header="applicant-tracker.assignInterviews"
    [open]="isAssignModalOpen"
    (closing)="onCancelAssigningInteriewers()"
>
    <p class="margin-bottom-0">{{ 'applicant-tracker.specifyTheDetailsForTheApplicantsInterview' | translate }}</p>
    <form [formGroup]="formGroup">
        <div class="app-grid">
            <mat-form-field class="margin-top-3 columns-8">
                <mat-label>{{ 'applicant-tracker.feedbackDueByLower' | translate }}</mat-label>
                <input
                    [matDatepicker]="feedbackDueDatePicker"
                    name="feedbackDueDateInput"
                    formControlName="feedbackDueBy"
                    data-cy="feedbackDueBy"
                    [min]="minDate"
                    [(ngModel)]="applicantInterview.feedbackDueDate"
                    matInput
                />
                <mat-datepicker #feedbackDueDatePicker></mat-datepicker>
                <mat-datepicker-toggle matSuffix [for]="feedbackDueDatePicker">
                    <mat-icon matDatepickerToggleIcon svgIcon="calendar"></mat-icon>
                </mat-datepicker-toggle>
            </mat-form-field>
        </div>

        <h4 class="margin-top-4 margin-bottom-0">{{ 'applicant-tracker.addRemoveInterviewers' | translate }}</h4>
        <p class="margin-bottom-1">{{ 'applicant-tracker.youCanOnlyRemoveInterviewersIf' | translate }}</p>
        <mat-divider></mat-divider>

        <ng-container formGroupName="myCheckboxGroup" *ngFor="let interviewer of interviewers">
            <div class="flex align-items-center margin-top-1 margin-bottom-1">
                <mat-checkbox
                    [formControlName]="interviewer.employee.id"
                    [name]="interviewer.employee.id"
                    (change)="interviewer.isSelected = $event.checked"
                >
                </mat-checkbox>
                <app-avatar class="margin-left-1" [employee]="interviewer.employee" [name]="true"></app-avatar>
            </div>
            <mat-divider></mat-divider>
        </ng-container>
    </form>
    <ui-dialog-footer>
        <ui-button type="ghost" (click)="onCancelAssigningInteriewers()">{{ 'cancel' | translate }}</ui-button>
        <ui-button type="primary" (click)="onSave(formGroup)">{{ 'save' | translate }}</ui-button>
    </ui-dialog-footer>
</ui-dialog>

<ui-dialog
    [open]="isDeleteModalOpen"
    (closing)="closeDeleteModal()"
    [header]="{
        key: 'applicant-tracker.deleteInterviewName',
        params: { interviewName: applicantInterview.interview?.name },
    }"
>
    <p [innerHTML]="'applicant-tracker.deletingApplicantsInterviewWillAlsoDeleteAllFeedback' | translate"></p>
    <ui-dialog-footer>
        <ui-button type="ghost" (click)="closeDeleteModal()">{{ 'cancel' | translate }}</ui-button>
        <ui-button type="danger" (click)="onDelete()">{{ 'delete' | translate }}</ui-button>
    </ui-dialog-footer>
</ui-dialog>

<div *ngIf="applicantInterview" class="ui basic segment" [class.loading]="isLoading">
    <app-header
        [back]="true"
        contextMenuType="material"
        [contextMenu]="hasRecruiterAccess"
        [title]="getApplicantInterviewHeader()"
    >
        <button mat-menu-item (click)="openAssignModal()">{{ 'edit' | translate }}</button>
        <button mat-menu-item (click)="openDeleteModal()">{{ 'delete' | translate }}</button>
    </app-header>

    <div class="app-grid">
        <div class="columns-3">
            <ui-card>
                <app-segment-header title="applicant-tracker.details"></app-segment-header>
                <div>
                    <div class="interview-attribute margin-bottom-3">
                        <div class="name margin-bottom-1">{{ 'applicant-tracker.applicantName' | translate }}</div>
                        <div class="value">
                            {{ applicantInterview.applicant?.fullName }}
                            <a (click)="goToApplicantPage(applicantInterview.applicant)">
                                <mat-icon class="margin-left-1" svgIcon="openInNew"></mat-icon>
                            </a>
                        </div>
                    </div>
                    <div class="interview-attribute margin-bottom-3">
                        <div class="name margin-bottom-1">{{ 'applicant-tracker.feedbackDueBy' | translate }}</div>
                        <div class="value">{{ applicantInterview.feedbackDueDate | appDate: 'longDate' }}</div>
                    </div>
                    <div class="interview-attribute margin-bottom-3">
                        <div class="name margin-bottom-1">{{ 'applicant-tracker.description' | translate }}</div>
                        <div class="value">{{ applicantInterview.interview?.description }}</div>
                    </div>
                </div>
            </ui-card>
        </div>
        <div class="columns-9">
            <app-table
                [table]="applicantInterviewersSummaryTable"
                [showSearch]="false"
                title="{{ 'applicant-tracker.summary' | translate }}"
                (menuItemSelected)="menuAction($event)"
                [useStickyHeader]="false"
            >
                <div class="empty">
                    <h2 class="ui centered header">{{ 'applicant-tracker.noApplicantInterviewers' | translate }}</h2>
                </div>
            </app-table>
            <app-applicant-interview-feedback-results
                *ngIf="assignedApplicantInterviewers.length"
                [interviewQuestionsWithFeedbackResults]="interviewQuestionsWithFeedbackResults"
                [applicantInterviewers]="assignedApplicantInterviewers"
            ></app-applicant-interview-feedback-results>
        </div>
    </div>
</div>
